"use client";
import { useEffect, useState } from "react";
import { Table, Tag, Select } from "antd";
import api from "../../api";
import PageHeader from "../../components/header/PageHeader";
import { formatDateTime } from "../../utils/helper";
import { useAuth } from "../../store/AuthContext";

const ACTION_COLOR = {
  CREATE: "success",
  UPDATE: "processing",
  DELETE: "error",
  LOGIN: "default",
  LOGOUT: "warning",
};

const MODEL_OPTIONS = [
  "Card",
  "Loan",
  "Promotion",
  "News",
  "NewsTaxonomy",
  "User",
  "Banner",
  "Category",
  "Issuer",
  "Staff",
];
const ACTION_OPTIONS = ["CREATE", "UPDATE", "DELETE", "LOGIN", "LOGOUT"];

export default function AuditLog() {
  const { user } = useAuth();
  const isAdmin = ["ADMIN", "OWNER"].includes(user?.role);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
  });
  const [filters, setFilters] = useState({
    model: undefined,
    action: undefined,
  });

  const fetchData = async (page = 1, limit = 10) => {
    setLoading(true);
    try {
      const res = await api.audit_list({ page, limit, ...filters });
      setData(res.data.data);
      setPagination((prev) => ({
        ...prev,
        page,
        limit,
        total: res.data.meta.total,
      }));
    } catch {
      // error handle
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  const columns = [
    {
      title: "Үйлдэл",
      dataIndex: "action",
      key: "action",
      render: (v) => <Tag color={ACTION_COLOR[v]}>{v}</Tag>,
    },
    {
      title: "Модель",
      dataIndex: "model",
      key: "model",
    },
    ...(isAdmin
      ? [
          {
            title: "Хэрэглэгч", // ADMIN л харна
            dataIndex: "user",
            key: "user",
            render: (u) => u?.name ?? "—",
          },
          //   {
          //     title: "IP", // ADMIN л харна
          //     dataIndex: "ip",
          //     key: "ip",
          //     render: (v) => v ?? "—",
          //   },
        ]
      : []),
    {
      title: "Огноо",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (v) => formatDateTime(v),
    },
  ];

  return (
    <section>
      <PageHeader
        title="Audit Log"
        sub={isAdmin ? "Бүх хэрэглэгчийн үйлдлийн түүх" : "Миний үйлдлийн түүх"}
      />

      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <Select
          placeholder="Модель"
          allowClear
          style={{ width: 160 }}
          options={MODEL_OPTIONS.map((m) => ({ label: m, value: m }))}
          onChange={(v) => setFilters((f) => ({ ...f, model: v }))}
        />
        <Select
          placeholder="Үйлдэл"
          allowClear
          style={{ width: 140 }}
          options={ACTION_OPTIONS.map((a) => ({ label: a, value: a }))}
          onChange={(v) => setFilters((f) => ({ ...f, action: v }))}
        />
      </div>

      <div className="table-wrap">
        <Table
          rowKey="id"
          columns={columns}
          dataSource={data}
          loading={{ spinning: loading, size: "small" }}
          size="middle"
          pagination={{
            current: pagination.page,
            pageSize: pagination.limit,
            total: pagination.total,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50"],
            showTotal: (total) => `Нийт ${total} бүртгэл`,
            onChange: (page, limit) => fetchData(page, limit),
          }}
        />
      </div>
    </section>
  );
}
